// extracted by mini-css-extract-plugin
export default {"videoSection":"styles_videoSection__RKJmz"};